var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalizeDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.5C4 11.3954 4.89543 10.5 6 10.5H15C16.1046 10.5 17 11.3954 17 12.5V12.5C17 13.6046 16.1046 14.5 15 14.5H6C4.89543 14.5 4 13.6046 4 12.5V12.5Z",
    stroke: "#3D8CD4",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5C12 20.7091 13.7909 22.5 16 22.5C18.2091 22.5 20 20.7091 20 18.5C20 16.2909 18.2091 14.5 16 14.5C15.8007 14.5 15.6047 14.5146 15.4132 14.5427M12 18.5C12 16.4902 13.4823 14.8266 15.4132 14.5427M12 18.5H6C4.89543 18.5 4 17.6046 4 16.5C4 15.3954 4.89543 14.5 6 14.5H15C15.1417 14.5 15.2799 14.5147 15.4132 14.5427",
    stroke: "#3D8CD4",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.08579L12.7071 2.79289C12.3166 2.40237 11.6834 2.40237 11.2929 2.79289L10 4.08579M12 7.5L12 3.08579",
    stroke: "#3D8CD4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalizeDeposit);
export default __webpack_public_path__ + "static/media/FINALIZE_DEPOSIT.4af200d508f5e7bf4c51b1d5e6c3256d.svg";
export { ForwardRef as ReactComponent };